import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=81415372"
import script from "./loginLayout.vue?vue&type=script&lang=js"
export * from "./loginLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports